<template>
    <section class="dropdown-product-details" @click="toggleShowInfo">
        <div class="head">
            <h3 class="title">{{ title }}</h3>
            <button :open="showInfo">
                <img src="/static/img/arrow-down.svg" alt="icon" title="icon">
            </button>
            <div class="container-text" v-if="showInfo">
                <p v-html="contentPanel"></p>
            </div>
        </div>
    </section>
</template>
  
<script lang="js">
export default {
    name: 'dropdown-product-details',
    props: ['title', 'contentPanel'],
    data() {
        return {
            showInfo: false
        }
    },
    methods: {
        toggleShowInfo: function () {
            this.showInfo = !this.showInfo;
        },
    },
    watch: {
      "$route.params.id"(){
        this.showInfo = false;
      }
    },
}
</script>
  
  


// WEBPACK FOOTER //
// src/components/view-parts/dropdown.vue